import React, { useState, useEffect } from "react";
import axios from "axios";
import Subscriber from "../components/Subscriber";

const Subscribers = () => {
    const [subscribers, setSubscribers] = useState([]);

    //get blogs
    const getAllsubscribers = async () => {
        try {
            const { data } = await axios.get("/api/v1/subscriber/all-subscribers");
            if (data?.success) {
                setSubscribers(data?.subscribers);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getAllsubscribers();
    }, []);

    return (
        <div style={{ padding: '20px', fontFamily: 'Arial' }}>
            <h1>Subscribers List</h1>
            {subscribers && subscribers.length > 0 ? (
                subscribers.map((subscriber) => (
                    <Subscriber
                        id={subscriber?._id}
                        isUser={localStorage.getItem("userId") === subscriber?.user?._id}
                        // isUser={true}
                        email={subscriber?.email}
                    />
                ))
            ) :
                (
                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        minHeight: "100vh",
                        textAlign: "center"
                    }}><p>No subscribers available... </p></div>
                )}
        </div>
    );
};

export default Subscribers;